import { KarigarShell } from "@/components/KarigarShell";
import { InstallAppPage } from "../settings/InstallAppPage";
import { useLanguage } from "@/i18n/language";

/**
 * The karigar's route to the install page.
 *
 * Karigar screens do not run through `AppShell`, so the page needs the karigar
 * frame — branded header and the four-tab bottom nav — to sit among them as
 * one of their own rather than a bare page floating outside the app.
 *
 * `active="home"` lights the Home tab: install is reached from the karigar's
 * own menu, and there is no tab for it. Highlighting nothing would look like a
 * broken page; highlighting Home is honest about where it was reached from.
 */
export function KarigarInstallPage() {
  const { t } = useLanguage();
  return (
    <KarigarShell active="home" title={t("ऐप इंस्टॉल करें", "Install app")}>
      <InstallAppPage />
    </KarigarShell>
  );
}
